<template>
  <div id="sobre">
    <b-row :style="tituloRowBG" class="tituloPaginaRow">
      <h1 class="tituloPagina">
        {{ tituloPagina }}
      </h1>
    </b-row>
    <b-row class="p-3 p-sm-0 p-md-0 p-lg-0 p-xl-0">
      <p v-html="textoSobre" :class="justifiedText"></p>
    </b-row>
  </div>
</template>

<script>
  import client from '@/main.js'
  export default {
    data() {
      return {
        client: null,
        tituloPagina: '',
        tituloRowBG: '',
        textoSobre: '',
        tituloContato: ''
      }
    },
    created() {
      let me = this
      me.client = client.CLIENT
      me.tituloPagina = client.clientData.about.title
      me.textoSobre = client.clientData.about.text
      me.tituloContato = client.clientData.about.contactText
      me.tituloRowBG = {
        backgroundImage:
          'url(' +
          require('@/assets/imagens/' + me.client + '/tituloPagFdo.png') +
          ')'
      }
    },
    computed: {
      justifiedText() {
        return this.client === 'DOE-AL' ? 'text-justify' : ''
      }
    }
  }
</script>

<style lang="scss">
  @import '../assets/scss/estilos.scss';
  .textoCinza {
    color: #b3b3b3;
  }
</style>



// WEBPACK FOOTER //
// src/components/Sobre.vue